<template>
  <div class="mv-bg-main">
    <el-card >
      <div slot="header" class="clearfix">
        <span>查询条件</span>
      </div>
      <el-form :inline="true" ref="searchForm" :model="form"  class="demo-form-inline " label-width="100px">
        <el-form-item label="业务系统" class="" prop="sys">
          <el-select v-model="form.sys" clearable filterable placeholder="请选择业务系统">
            <el-option :label="item.systemName" :value="item.systemId" v-for="(item, $index) in sysData" :key="$index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产品名称" class="" prop="cusName">
          <el-input v-model="form.cusName" clearable placeholder="请输入产品名称"></el-input>
        </el-form-item>
        <el-form-item label="产品状态" class="" prop="cusState">
          <el-select v-model="form.cusState" clearable filterable placeholder="请选择产品状态">
            <el-option label="全部" value=""></el-option>
            <el-option label="启用" value="false"></el-option>
            <el-option label="禁用" value="true"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产品类型" class="" prop="cusType">
          <el-select v-model="form.cusType" clearable filterable placeholder="请选择产品类型">
            <el-option v-for="(item, $index) in typeData" :key="$index" :label="item.prodTypeNameCn" :value="item.prodTypeId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间" prop="date" class="">
          <el-date-picker
            v-model="form.date"
            :editable = "editable"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <!-- <el-form-item label="是否缓存" class="" prop="cache">
          <el-select v-model="form.cache" filterable clearable placeholder="请选择缓存">
            <el-option label="全部" value=""></el-option>
            <el-option label="是" value="true"></el-option>
            <el-option label="否" value="false"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item class="float-r">
          <el-button size="small" @click="onReset('searchForm')">重置</el-button>
          <el-button type="primary" size="small" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card class="m-top">
      <div slot="header" class="clearfix">
        <span class="card-title">查询结果</span>
        <el-button type="primary" size="small" style="float: right; margin-top: -10px; margin-right: 10px;" @click="handleAdd" icon="el-icon-plus"></el-button>
      </div>
      <el-table
        :data="tableData"
        :default-sort = "{prop: 'createTime', order: 'descending'}"
        @sort-change="createTimeChange"
        style="width: 100%">
        <el-table-column
          label="业务系统"
          :show-overflow-tooltip="tooltip"
          width="80">
          <template slot-scope="scope">
            <span >{{ scope.row.sysName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="产品编号"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span class="link" @click="detail(scope.$index, scope.row)">{{ scope.row.prodId }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="产品名称"
          :show-overflow-tooltip="tooltip"
          width="219">
          <template slot-scope="scope">
            <span >{{ scope.row.prodNameCn }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="产品英文名称"
          :show-overflow-tooltip="tooltip"
          width="219">
          <template slot-scope="scope">
            <span >{{ scope.row.prodNameEn }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="计价规则"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.chargePolicy }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="售价(元)"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.price }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="状态"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.turnOff ? '禁用' : '启用'}}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          label="是否启用缓存"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.cached ? '是' : '否'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="缓存时长(小时)"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.cacheExpireTime }}</span>
          </template>
        </el-table-column> -->
        <el-table-column
          label="创建时间"
          :show-overflow-tooltip="tooltip"
          sortable
          prop="createTime"
          width="180">
          <!-- <template slot-scope="scope">
            <span >{{ scope.row.createTime }}</span>
          </template> -->
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="140">
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-switch
              v-model="scope.row.turnOff"
              :active-value="on"
              :inactive-value="off"
              @change="change(scope.$index, scope.row)" >
            </el-switch>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt center"
        background
        @size-change="handleSizeChange"
        :current-page.sync="currentPage"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="page"
        layout="total, sizes, prev, pager, next"
        :total="total">
      </el-pagination>
      <el-dialog title="云端产品详情" width="850px" center :modal-append-to-body='false' :visible.sync="detailDialog">
      <el-form :model="detailForm" label-width="150px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="产品编号:" >
              <el-input style="width: 217px;" disabled  v-model="detailForm.prodId" ></el-input>
            </el-form-item>
            <el-form-item label="产品名称:" >
              <el-input style="width: 217px;" disabled  v-model="detailForm.prodNameCn" ></el-input>
            </el-form-item>
            <el-form-item label="产品英文名称:" >
              <el-input style="width: 217px;" disabled  v-model="detailForm.prodNameEn" ></el-input>
            </el-form-item>
            <el-form-item label="产品类型:" >
              <el-input style="width: 217px;" disabled  v-model="detailForm.prodTypeName" ></el-input>
            </el-form-item>
            <el-form-item label="状态:" >
              <span>{{detailForm.turnOff ? '禁用' : '开启' }}</span>
            </el-form-item>
            <el-form-item label="计价策略:" >
              <el-input style="width: 217px;" disabled  v-model="detailForm.chargePolicy" ></el-input>
            </el-form-item>
            <el-form-item label="指导价格:" >
              <el-input style="width: 217px;" disabled  v-model="detailForm.price" ></el-input>
            </el-form-item>
            <el-form-item label="创建人:" >
              <el-input style="width: 217px;" disabled  v-model="detailForm.creator" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!-- <el-form-item label="是否缓存:" >
              <span>{{detailForm.cached ? '是' : '否' }}</span>
            </el-form-item>
            <el-form-item label="缓存超时时间:" >
              <el-input style="width: 217px;" disabled  v-model="detailForm.cacheExpireTime" ></el-input>
            </el-form-item> -->
            <el-form-item label="是否需要告警通道:" >
              <span>{{detailForm.needAlarm ? '是' : '否' }}</span>
            </el-form-item>
            <el-form-item label="告警通道:" >
              <span>{{detailForm.alarmType}}</span>
            </el-form-item>
            <el-form-item label="告警超时时间:" >
              <el-input style="width: 217px;" disabled  v-model="detailForm.alarmTimeout" ></el-input>
            </el-form-item>
            <el-form-item label="服务超时时间:" >
              <el-input style="width: 217px;" disabled  v-model="detailForm.serviceTimeout" ></el-input>
            </el-form-item>
            <el-form-item label="创建时间:" >
              <el-input style="width: 217px;" disabled  v-model="detailForm.createTime" ></el-input>
            </el-form-item>
            <el-form-item label="描述:" >
              <el-input type="textarea" disabled style="width: 217px;" v-model="detailForm.prodDesc"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
    </el-card>
  </div>
</template>
<style lang="scss" rel="stylesheet/scss">
@import "../../assets/sass/base.scss";
.custome-height {
  height: 700px;
  overflow-y: scroll;
}
.ml {
  margin-left: 10px;
}
.mt {
  margin-top: 10px;
}
.center {
  text-align: right;
}
.flex {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}
.wid {
  flex: 1;
}
</style>
<script>
export default {
  name: 'proMain',
  data () {
    return {
      form: {
        sys: '',
        sysData: [],
        cusName: '',
        cusState: '',
        cusType: '',
        typeData: [],
        date: '',
        cache: ''
      },
      changeSize: true,
      detailDialog: false,
      detailForm: {
        prodId: '',
        cacheExpireTime: '',
        prodNameCn: '',
        cached: '',
        alarmType: '',
        prodNameEn: '',
        prodTypeName: '',
        turnOff: '',
        chargePolicy: '',
        price: '',
        needAlarm: '',
        alarmTimeout: '',
        serviceTimeout: '',
        creator: '',
        createTime: '',
        prodDesc: ''
      },
      tooltip: true,
      createTimeDesc: null,
      editable: false,
      on: false,
      off: true,
      tableData: [],
      currentPage: 1,
      page: 10,
      total: 100,
      proId: ''
    }
  },
  computed: {
    typeData () {
      return this.$store.state.productType
    },
    sysData () {
      return this.$store.state.sysData
    }
  },
  activated () {
    this.query()
  },
  methods: {
    onSubmit () {
      this.currentPage = 1
      this.query()
    },
    /* 重置操作 */
    onReset (formName) {
      this.$refs[formName].resetFields()
    },
    createTimeChange (column) {
      if (column.prop === 'createTime') {
        if (column.order === 'descending') {
          this.createTimeDesc = true
        } else if (column.order === 'ascending') {
          this.createTimeDesc = false
        }
      }
      this.query()
    },
    handleSizeChange (val) {
      this.page = val
      this.currentPage = 1
      this.query()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.query()
    },
    detail (index, val) {
      let op = {}
      op.prodId = val.prodId
      let _this = this
      this.$axios({
        method: 'post',
        url: _this.$API.product.queryProdInfoDetail,
        data: op
      }).then((response) => {
        let data = response.data.resData
        let alarmType = ''
        if (data.alarmType === '0,1') {
          alarmType = '短信 邮件'
        } else if (data.alarmType === '0') {
          alarmType = '短信'
        } else if (data.alarmType === '1') {
          alarmType = '邮件'
        }
        _this.detailForm.prodId = data.prodId
        _this.detailForm.cacheExpireTime = data.cacheExpireTime
        _this.detailForm.cached = data.cached
        _this.detailForm.prodNameCn = data.prodNameCn
        _this.detailForm.prodNameEn = data.prodNameEn
        _this.detailForm.prodTypeName = data.prodTypeName
        _this.detailForm.turnOff = data.turnOff
        _this.detailForm.chargePolicy = data.chargePolicy
        _this.detailForm.price = data.price
        _this.detailForm.needAlarm = data.needAlarm
        _this.detailForm.alarmTimeout = data.alarmTimeout
        _this.detailForm.serviceTimeout = data.serviceTimeout
        _this.detailForm.creator = data.creator
        _this.detailForm.createTime = data.createTime
        _this.detailForm.createTime = data.createTime
        _this.detailForm.prodDesc = data.prodDesc
        _this.detailForm.alarmType = alarmType
        console.log(data)
        _this.detailDialog = true
      }).catch((err) => {
        console.log(err)
      })
    },
    handleEdit (index, value) {
      // this.dialogFormVisible = true
      // this.title = '编辑产品'
      // this.proId = value.prodId
      // this.queryPro(value.prodId)
      this.$router.push({
        name: 'editMain',
        query: {
          id: value.prodId,
          num: this.currentPage,
          size: this.page,
          isfresh: true
        }
      })
    },
    handleAdd () { // 新增产品
      this.$router.push({
        name: 'addProMain',
        query: {
          num: this.currentPage,
          size: this.page
        }
      })
    },
    change (index, value) {
      console.log(value)
      let op = {}
      op.prodId = value.prodId
      op.turnOff = value.turnOff
      let _this = this
      if (value.turnOff) {
        value.turnOff = !value.turnOff
        this.$confirm('是否确定停用产品?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$axios({
            method: 'post',
            url: _this.$API.product.changeStatus,
            data: op
          }).then((response) => {
            console.log(response)
            if (response.data.resCode === 1) {
              _this.$message.success('服务停用成功!')
              _this.query()
            }
          }).catch((err) => {
            console.log(err)
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      } else {
        value.turnOff = !value.turnOff
        this.$confirm('是否确定启用产品?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$axios({
            method: 'post',
            url: _this.$API.product.changeStatus,
            data: op
          }).then((response) => {
            console.log(response)
            if (response.data.resCode === 1) {
              _this.$message.success('服务启用成功!')
              _this.query()
            }
          }).catch((err) => {
            console.log(err)
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      }
    },
    initData () {
      if (!this.typeData.length) { // 是否请求产品类型
        this.$store.dispatch('getProductType')
      }
      this.$store.dispatch('getSystem') // 请求业务系统
      this.query()
    },
    query () {
      let op = {}
      let _this = this
      let id = this.form.sys
      let sysIds = []
      if (id && id !== 0) {
        sysIds.push(id)
      }
      op.pageNum = this.currentPage
      op.pageSize = this.page
      op.sysIds = sysIds
      op.prodName = this.form.cusName
      op.prodTypeId = this.form.cusType
      op.turnOff = this.form.cusState
      op.cached = this.form.cache
      op.createTimeDesc = this.createTimeDesc
      op.createTimeBegin = this.form.date ? this.form.date[0] : ''
      op.createTimeEnd = this.form.date ? this.form.date[1] : ''
      this.$axios({
        url: _this.$API.product.queryProdInfoByPage,
        method: 'post',
        data: op
      }).then((response) => {
        _this.tableData = response.data.resData.resultList
        _this.total = response.data.resData.total
      }).catch((err) => {
        console.log(err)
      })
    }
  },
  mounted () {
    if (this.$route.query.num) {
      this.changeSize = false
      this.currentPage = Number(this.$route.query.num)
      this.page = Number(this.$route.query.size)
      this.changeSize = true
    }
    this.initData()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/proManage/proMain.vue